import qrcode from "qrcode-generator";
import { useMemo } from "react";

/** A QR code for a link, drawn as one SVG path: dark squares on white, with a quiet border. */
export function PhoneQr({ link, size = 132 }: { link: string; size?: number }) {
  const { count, path } = useMemo(() => {
    const qr = qrcode(0, "M");
    qr.addData(link);
    qr.make();
    const modules = qr.getModuleCount();
    let d = "";
    for (let row = 0; row < modules; row++) {
      for (let col = 0; col < modules; col++) {
        if (qr.isDark(row, col)) d += `M${String(col)} ${String(row)}h1v1h-1z`;
      }
    }
    return { count: modules, path: d };
  }, [link]);

  const margin = 3;
  const box = count + margin * 2;
  return (
    <svg
      className="phone-qr"
      width={size}
      height={size}
      viewBox={`${String(-margin)} ${String(-margin)} ${String(box)} ${String(box)}`}
      shapeRendering="crispEdges"
      role="img"
      aria-label="QR code to open this report on your phone"
    >
      <rect x={-margin} y={-margin} width={box} height={box} fill="#fff" />
      <path d={path} fill="#000" />
    </svg>
  );
}
